import {GET_YEARS } from "../actions/types";

const initialState=[]

export default function years(state = initialState, action) {
    switch (action.type) {
      case GET_YEARS:
        return action.payload;
      default:
        return state;
    }
  }